import { render, staticRenderFns } from "./TaxiVehicleInfo.vue?vue&type=template&id=60a88cc6&scoped=true"
import script from "./TaxiVehicleInfo.vue?vue&type=script&lang=js"
export * from "./TaxiVehicleInfo.vue?vue&type=script&lang=js"
import style0 from "./TaxiVehicleInfo.vue?vue&type=style&index=0&id=60a88cc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a88cc6",
  null
  
)

export default component.exports